
// Session expired alert styles
const SESSION_ALERT_STYLES = `
  .session-expired-alert {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #8a0f1c;
    color: white;
    padding: 16px 20px;
    text-align: center;
    z-index: 9999;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    animation: slideDown 0.3s ease-out;
  }
  
  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
  
  .session-expired-alert a {
    color: white;
    text-decoration: underline;
    font-weight: bold;
  }
  
  .session-expired-alert a:hover {
    color: #ffeb3b;
  }
  
  .session-expired-alert button {
    float: right;
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 20px;
    margin-left: 16px;
    padding: 0 8px;
  }
  
  .session-expired-alert button:hover {
    color: #ffeb3b;
  }
`;

// Inject styles once
if (typeof document !== 'undefined' && !document.getElementById('session-alert-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'session-alert-styles';
  styleSheet.innerText = SESSION_ALERT_STYLES;
  document.head.appendChild(styleSheet);
}

let alertTimeout = null;
let currentAlert = null;

export function showSessionExpiredAlert() {
  // Don't show duplicate alerts
  if (currentAlert && document.body.contains(currentAlert)) {
    return;
  }
  
  // Clear existing timeout
  if (alertTimeout) {
    clearTimeout(alertTimeout);
  }
  
  // Create alert - NO AUTO REFRESH
  const alertDiv = document.createElement('div');
  alertDiv.className = 'session-expired-alert';
  alertDiv.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; gap: 16px; flex-wrap: wrap;">
      <div style="display: flex; align-items: center; gap: 12px;">
        <span style="font-size: 24px;">⚠️</span>
        <div>
          <strong style="font-size: 16px;">Session Expired</strong>
          <div style="font-size: 13px; margin-top: 4px;">
            Your session has expired. Please save your work and
            <a href="/login" style="color: white; text-decoration: underline; font-weight: bold;">login again</a>
            to continue.
          </div>
        </div>
      </div>
      <button onclick="this.closest('.session-expired-alert').remove()" style="
        background: rgba(255,255,255,0.2);
        border: none;
        border-radius: 4px;
        padding: 6px 12px;
        color: white;
        cursor: pointer;
      ">Dismiss</button>
    </div>
  `;
  
  document.body.insertAdjacentElement('afterbegin', alertDiv);
  currentAlert = alertDiv;
  
  // Remove alert after 30 seconds (but NO auto refresh)
  alertTimeout = setTimeout(() => {
    if (alertDiv && document.body.contains(alertDiv)) {
      alertDiv.remove();
      currentAlert = null;
    }
  }, 30000);
  
  // Remove alert on dismiss button click
  alertDiv.querySelector('button').onclick = () => {
    if (alertDiv && document.body.contains(alertDiv)) {
      alertDiv.remove();
      currentAlert = null;
    }
    if (alertTimeout) clearTimeout(alertTimeout);
  };
}

// Fix fetch interceptor to NOT refresh on 401
export function setupSessionInterceptors() {
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const url = args[0];
    const isApiRequest = typeof url === 'string' && 
                         (url.includes('/api/') || url.includes('/dhis2/'));
    
    try {
      const response = await originalFetch(...args);
      
      // Only show alert for API requests, but DON'T refresh
      if (response.status === 401 && isApiRequest) {
        console.warn('⚠️ API session expired - showing alert');
        showSessionExpiredAlert();
      }
      
      return response;
    } catch (error) {
      throw error;
    }
  };
}